const PROJECT_SCOPED_LANGUAGE_QUERY_KEYS = [
  'getCard',
  'getCard.infinite',
  'getLiveProjectCommandContexts',
  'getLiveProjectCommandContexts.infinite',
  'getProjectCompliance',
  'getProjectCompliance.infinite',
  'listLatestUpdateCards',
  'listLatestUpdateCards.infinite',
  'listLiveFavoriteCards',
  'listLiveFavoriteCards.infinite',
  'listLiveProjectCards',
  'listLiveProjectCards.infinite',
  'listProjectTriggers',
  'listProjectTriggers.infinite',
  'preloadCards',
  'preloadCards.infinite',
  'searchCards',
  'searchCards.infinite',
] as const;

const GLOBAL_LANGUAGE_QUERY_KEYS = [
  // Keyed by cardId only, so it cannot be narrowed to the selected project.
  'getCardContent',
  'getCardContent.infinite',
  'listDecisionTrees',
  'listDecisionTrees.infinite',
  'listLiveFavoriteCards',
  'listLiveFavoriteCards.infinite',
  'listLiveProjects',
  'listLiveProjects.infinite',
] as const;

function readProjectIdFromQueryVariables(queryVariables: unknown): string | undefined {
  if (!queryVariables || typeof queryVariables !== 'object') {
    return undefined;
  }

  const variables = queryVariables as {
    input?: { id?: string };
    infiniteInput?: { projectId?: string };
  };

  return variables.input?.id ?? variables.infiniteInput?.projectId;
}

export function isLanguageDependentQuery(
  queryKey: readonly unknown[],
  projectId?: string,
) {
  const [queryName, queryVariables] = queryKey;

  if (typeof queryName !== 'string') {
    return false;
  }

  const isProjectKey = PROJECT_SCOPED_LANGUAGE_QUERY_KEYS.includes(queryName as typeof PROJECT_SCOPED_LANGUAGE_QUERY_KEYS[number]);
  const isGlobalKey = GLOBAL_LANGUAGE_QUERY_KEYS.includes(queryName as typeof GLOBAL_LANGUAGE_QUERY_KEYS[number]);

  if (!isProjectKey && !isGlobalKey) { return false; }
  if (isGlobalKey) { return true; }
  if (!projectId) { return true; }
  return readProjectIdFromQueryVariables(queryVariables) === projectId;
}

export function invalidateLanguageDependentQueries(queryClient: {
  invalidateQueries: (filters: { predicate: (query: { queryKey: readonly unknown[] }) => boolean; refetchType: 'active' }) => Promise<unknown>;
}, projectId?: string) {
  return queryClient.invalidateQueries({
    predicate: (query) => isLanguageDependentQuery(query.queryKey, projectId),
    refetchType: 'active',
  });
}
